import React, { useState, useEffect,useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import useUsuario from "../../../hooks/useUsuario";
import * as Yup from "yup";
import * as Iconsax from "iconsax-react";
import { Field,FieldArray, Formik ,useFormik,FormikProvider} from "formik";
import { ActualizarEstadosUsuarios ,ListadoCapacitacionFinalizadosPorId,ObtenerCategoriaCapacitacion,RegistrarCapacitacionObligatoria,ObtenerCapacitacionObligatoriaPorId,ActualizarCapacitacionObligatoria, RegistrarCategoriaCapacitacion} from "../../../service/CapacitacionService";
import ToastEva from "../../../components/Toast/ToastEva";
import TextareaDefault from "../../../components/TextArea/TextArea";
import InputDefault from "../../../components/InputDefault/InputDefault";
import InputIcon from "../../../components/InputIcon/InputIcon";
import Boton from "../../../components/Boton/Boton";
import DropdownDefault from "../../../components/DropdownDefault/Dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import BotonEva from '../../../components/Boton/Boton';
//import "../../Metricas/Metricas.scss"
//import { ObtenerSeccion,ObtenerReglamentoId,Registrar,Actualizar,RegistrarSeccion } from "../../../service/SomosinService";

const ActivarFinalizados = () => {
  const navigate = useNavigate();
  const [tituloPagina, setTituloPagina] = useState("Crear nueva capacitación");
  const [modoEdicion, setModoEdicion] = useState(false);
  const [capaObligatoria, setCapaObligatoria] = useState([]); // null al inicio
  const toast = useRef(null);

  let { idCapacitacion } = useParams();

  useEffect(() => {
    const ObtenerPorId = async () => {
      let jwt = window.localStorage.getItem("jwt");
      let Id = idCapacitacion;
      await ListadoCapacitacionFinalizadosPorId({ jwt, Id }).then((data) => {
        console.log("data que viene del servicio:", data);
        setCapaObligatoria(data); // data es un array
      });
    };
    if (idCapacitacion) {
      ObtenerPorId();
    }
  }, [idCapacitacion]);

  useEffect(() => {
    if (capaObligatoria && !modoEdicion) {
      setTituloPagina("Activar Finalizados");
      setModoEdicion(true);
    }
  }, [capaObligatoria]);

 const guardarSeleccionados = async () => {
    let jwt = window.localStorage.getItem("jwt");
    const seleccionados = capaObligatoria.filter(item => item.estado === true);

    await ActualizarEstadosUsuarios({seleccionados,jwt})
      .then((data) => {
        console.log("data que viene del servicio:", data);
        toast.current.show({severity:'success', summary: 'Success', detail:"Se restablecio exitosamente.", life: 7000})

        let Id = idCapacitacion;
        return ListadoCapacitacionFinalizadosPorId({ jwt, Id });
      })
      .then((nuevaData) => {
      setCapaObligatoria(nuevaData);
    })
    .catch((errors) => {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errors.message,
        life: 4000
      });
    });
};


  // Mientras no hay data -> mostrar cargando
// if (!Array.isArray(capaObligatoria) || capaObligatoria.length === 0) {
//   return <div>Cargando datos...</div>;
// }

  return (
    <div className="eva-metricas" style={{ marginLeft: 40 ,width:1082,margin:"Auto"}}>
      <ToastEva ref={toast} position="top-center"></ToastEva>

      <div className="eva-dashboard-header">
        <div>
          <i href="#" onClick={() => navigate(-1)} className="p-eva-icon-atras">
            <Iconsax.ArrowLeft color="#000000" />
          </i>
        </div>
        <div>{tituloPagina && <label htmlFor="header">{tituloPagina} </label>}</div>
      </div>

      <div className="finalizados-usuarios">
        {/* <div className="finalizados-usuarios-header">
          <div className="header-metricas" style={{ marginRight: 26 }}>
            Colaboradores que más interactúan
          </div>
        </div> */}

        <div className="usuarios-lista">
          <div className="usuarios-item-header">
            <div className="titulo" style={{ marginLeft: 80, width: 280 }}>Nombre de Usuario</div>
            <div className="titulo" style={{ width: 170 }}>Intentos</div>
            <div className="titulo" style={{ width: 168 }}>Fecha</div>
            <div className="titulo" style={{ width: 168 }}>Seleccionar</div>
          </div>

          {Array.isArray(capaObligatoria) && capaObligatoria.map((item, i) => (
            
            <div className="usuarios-item" key={i}>
              <div className="usuarios-item-nombre p-eva-labelForm">{item.nombre}</div>

              <div className="usuarios-item-intentos p-eva-labelForm">{item.intentos}</div>

              <div className="usuarios-item-fecha p-eva-labelForm">{item.fechaCompletada
                     ? new Date(item.fechaCompletada).toLocaleDateString("es-PE", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                    })
                    : ""
                }</div>

                 <div className="usuarios-item-Checkpoint">
                    <input
                        type="checkbox"
                        checked={item.estado}
                        onChange={(e) => {
                        const updated = [...capaObligatoria];
                        updated[i].estado = e.target.checked;
                        setCapaObligatoria(updated);

                        //console.log("Usuario:", item.idUsuario, "nuevo estado:", e.target.checked);
                        // opcional: llamar al backend aquí
                        }}
                    />
                </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 20, textAlign: "center" }}>
            <BotonEva 
                nombre="Enviar" 
                color="primary" 
                metodoClick={guardarSeleccionados} 
                  disabled={
                     !Array.isArray(capaObligatoria) ||
                      capaObligatoria.length === 0 ||
                      !capaObligatoria.some(item => item.estado)
                  }
            />
        </div>
      </div>
    </div>
  );
};

export default ActivarFinalizados;